app.factory('loginService', function ($document, $http) {
    var $body = $document.find('body');
    var isLoggedIn = $body.attr('data-app-login-state') === 'true';
    var loginPagePath = $body.attr('data-app-login-page-path');
    var pathInfo = $body.attr('data-app-path-info');
    var currentUser;
    if (isLoggedIn) {
        $http.get('/profile/me').then((response) => {
            currentUser = response.data;
        });
    }

    return {
        get isLoggedIn() {
            return isLoggedIn;
        },
        get currentUser() {
            return currentUser;
        },

        /**
         *
         * @param {Boolean} returnToCurrentPage
         * @param {Array} additionalArgs ['arg1=val1', 'arg2=val2']
         */
        redirectToLoginScreen: function (returnToCurrentPage, additionalArgs) {
            var url = loginPagePath;
            var args = [];

            if (returnToCurrentPage) {
                args.push('_target_path=' + encodeURIComponent(pathInfo));
            }

            if (additionalArgs) {
                args = args.concat(additionalArgs);
            }

            window.location = url + (args.length ? '?' : '') + args.join('&');
        }
    };
});
